import { cn } from '@/lib/utils';

import { providerIcon, providerName } from '../internals/providerIdentity';
import { sizingClass } from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

const TILE_CLASS = {
  md: 'size-[var(--ac-tile-md)] rounded-[calc(5*var(--ac-u))]',
  sm: 'size-[var(--ac-tile)] rounded-[calc(4*var(--ac-u))]',
};
const GLYPH_CLASS = {
  md: 'size-[var(--ac-tile-md-glyph)]',
  sm: 'size-[var(--ac-tile-glyph)]',
};

export const ProviderIcon: ComponentFn<typeof catalog, 'ProviderIcon'> = ({
  props,
}) => {
  const Icon = providerIcon(props.provider);
  const size = props.size ?? 'md';
  return (
    <span
      className={cn(
        'relative inline-block',
        sizingClass(props.sizing) || 'shrink-0'
      )}
    >
      <span
        role="img"
        aria-label={providerName(props.provider)}
        className={cn(
          'flex items-center justify-center border border-border bg-[var(--card-tile)]',
          TILE_CLASS[size]
        )}
      >
        <Icon className={GLYPH_CLASS[size]} />
      </span>
      {props.alert ? (
        <span
          aria-hidden="true"
          className="absolute right-[calc(-2*var(--ac-u))] top-[calc(-2*var(--ac-u))] size-[calc(8*var(--ac-u))] rounded-full bg-danger-9 ring-2 ring-background"
        />
      ) : null}
    </span>
  );
};
